import { useEffect } from "react";

/**
 * Ref-counted scroll lock for full-screen modals on mobile Safari.
 * MUI's Modal scroll lock only sets overflow:hidden; iOS often still scrolls
 * the page behind. This adds position:fixed + scroll restoration.
 */
let lockCount = 0;
let savedScrollY = 0;

function applyLock() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    const body = document.body;
    const html = document.documentElement;
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${savedScrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
  }
  lockCount += 1;
}

function releaseLock() {
  if (typeof document === "undefined") return;
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0) return;

  const body = document.body;
  const html = document.documentElement;
  const y = savedScrollY;

  body.style.overflow = "";
  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  body.style.width = "";
  html.style.overflow = "";

  window.scrollTo(0, y);
}

export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    applyLock();
    return () => {
      releaseLock();
    };
  }, [locked]);
}
